import { Interface } from "../types";
import { atomWithRefresh } from "../utils";

export const interfacesAtom_SUSPENDS = atomWithRefresh<Promise<Interface[]>>(
  async () => {
    try {
      const res = await fetch(`/api/canvasui/interfaces`);

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.errors);
      }

      return await res.json();
    } catch {
      return [];
    }
  },
);

interfacesAtom_SUSPENDS.debugLabel = "interfacesAtom_SUSPENDS";
